import { createFileRoute } from "@tanstack/react-router";
import { AppDetail } from "../../features/functions/app-detail";

export const Route = createFileRoute("/_authed/$org/$project/apps/$name")({ component: AppPage });

function AppPage() {
  const { org, project, name } = Route.useParams();
  return <AppDetail scope={{ org, project }} name={name} />;
}
